export default __webpack_public_path__ + "static/media/Background_00173.fca9a82a.png";